import { render, staticRenderFns } from "./default.vue?vue&type=template&id=edaf4374&scoped=true&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"
import style0 from "./default.vue?vue&type=style&index=0&id=edaf4374&prod&lang=less&scoped=true&"
import style1 from "./default.vue?vue&type=style&index=1&id=edaf4374&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edaf4374",
  null
  
)

export default component.exports